module.exports = __webpack_public_path__ + "static/media/Ajax.20bfbfa0.jpg";